module.exports = __webpack_public_path__ + "img/plus-rounded.f87bc2e5.svg";